import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import BottomSheet from 'components/DesignSystem/BottomSheet';
import { LOCATION_COLUMNS } from 'helper/Meteorology/Agro/Overview/locationsTable';
import {
  selectAgroOverviewTableSortBy,
  selectAgroOverviewTableSortDirection,
  setTableSortBy,
  setTableSortDirection,
} from 'redux/reducers/meteorologyAgroOverviewDashboardReducer';

import './index.scss';

const SORT_OPTIONS = LOCATION_COLUMNS.map((c) => ({
  value: c.key,
  label: c.sortLabel ?? c.label,
}));

export default function SortSheet({
  open,
  dismiss,
}: {
  open: boolean;
  dismiss: () => void;
}) {
  const dispatch = useDispatch();
  const sortBy = useSelector(selectAgroOverviewTableSortBy);
  const sortDirection = useSelector(selectAgroOverviewTableSortDirection);

  return (
    <BottomSheet open={open} dismiss={dismiss} title="Ordenar" className="agro-overview-mobile-sort-sheet">
      <div className="agro-overview-mobile-sort-list">
        {SORT_OPTIONS.map((option) => (
          <button
            key={option.value}
            type="button"
            className={`agro-overview-mobile-sort-row${option.value === sortBy ? ' selected' : ''}`}
            onClick={() => dispatch(setTableSortBy(option.value))}
            aria-pressed={option.value === sortBy}
          >
            {option.label}
          </button>
        ))}
      </div>
      <button
        type="button"
        className="agro-overview-mobile-sort-direction"
        onClick={() => dispatch(setTableSortDirection(sortDirection === 'asc' ? 'desc' : 'asc'))}
      >
        {`Direção: ${sortDirection === 'asc' ? 'Crescente' : 'Decrescente'}`}
      </button>
    </BottomSheet>
  );
}
